<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" :dark="true" @goMore="starHome" :page-index="filterData.pageIndex" :page-size="filterData.pageSize" :total="total" @changePage="changePage"/>
            <ul class="resource-list" v-if="list.length">
                <li class="resource-list-item" v-for="item in list" :key="item.assetId" @click="toDetail(item.assetId)">
                    <div class="list-item-link" v-link="linkUrl(item.assetId)">
                        <div class="list-item-img">
                            <img :src="CommonFileType(item.firstMaterialType, 'big')" alt="">
                        </div>
                        <div class="list-item-content">
                            <div class="resource-title text-overflow" :title="item.assetTitle">
                                {{item.assetTitle}}
                            </div>
                            <span v-if="item.tagName" class="tag" :class="`tag-${item.tagIndex}`">{{item.tagName}}</span>
                            <div class="resource-desc-box">
                                <div class="flex-start">
                                    <div class="publish-name text-overflow" :title="`发布人：${item.creatorName}`">{{item.creatorName}}</div>
                                    <div class="publish-label">发布</div>
                                </div>
                                <div>
                                    <span>
                                        <i class="iconfont icon-xiazai"></i>
                                        <span class="download-num">{{(item.downloadCount>=1000? '999+':item.downloadCount) || 0}}</span>
                                    </span>
                                    <span class="ml12">
                                        <i class="iconfont icon-a-zhucedenglu-kejian3x"></i>
                                        <span class="download-num">{{(item.browseCount>=1000? '999+':item.browseCount) || 0}}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData
                v-else
                class="no-data"
                url="no-resource.png"
                info="暂无资源"/>
        </div>
    </div>  
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/common-index.vue'
import BigNoData from '@/components/no-data.vue'
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer'
import { CommonFileType } from '@/views/resource-issue/resource-issue.js';
import { jumpHref } from '@/router/jumpHref.js';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    }
})

const store = useStore()
let total = ref(0);
const list = ref([]);
const loading = ref(false);
let filterData = ref({
    pageSize: 6,
    pageIndex: 1,
    orderBy: 'desc', // 升降序 asc-升序,desc-降序
    sortBy: 'hotNum', // 排序字段 hotNum-热度
    openScope: 'community_open'
});
const realList = computed(() => {
    return list.value?.length && list.value.slice(0, 4) || [];
})

const getList = function(){
    loading.value = true;
    G_transmit('getCommunityAssetList', {
        name: 'getCommunityAssetList',
        queries: {
            ...filterData.value,
            requestSource: 'homepage'
        }
    }).then(res => {
        let data = res?.data?.rows || [];
        list.value = data.length && data.map(item => {
            let tag = fmtTag(item) || {};
            item.tagName = tag.categoryName;
            item.tagIndex = tag.categoryColorIndex;
            return item;
        })
        total.value = res?.data?.total || 0
        loading.value = false
        console.log('resource', list.value)

    }).finally(() => {
        loading.value = false;
    });
}

const changePage = (pageIndex) => {
    console.log('pageIndex1', pageIndex)
    filterData.value.pageIndex = pageIndex
    getList();
}

function starHome () {
    pageJump({name: 'resource'});
}

// 跳转资源详情
function toDetail(id) {
    pageJump(jumpHref.resource.detail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.resource.detail(id),
        className: 'link-item'
    }
}

function fmtTag(item) {
    return item.categoryInfoList?.length && item.categoryInfoList[0] || {};
}



onMounted(() => {
    getList()
})

</script>

<style lang="scss" scoped>
.common-module-page {
    // width: 100vw;
    background: #F8F8F8;
    padding-bottom: 30px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.resource-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}
.resource-list-item {
    box-sizing: border-box;
    width: 386px;
    height: 124px;
    background: #FFFFFF;
    border-radius: 4px;
    position: relative;
    margin-top: 20px;
    margin-left: 20px;
    display: flex;
    padding: 20px 20px 16px;
    cursor: pointer;
    &:nth-child(1), &:nth-child(2), &:nth-child(3) {
        margin-top: 0;
    }
    &:hover {
        box-shadow: 0px 4px 12px 0px rgba(37,54,82,0.08);
    }
    .list-item-img {
        width: 50px;
        height: 60px;
        img {
            width: 50px;
            height: 60px;
        }
    }
    .list-item-content {
        box-sizing: border-box;
        width: 0;
        flex: 1;
        margin-left: 16px;
        .resource-title {
            font-size: 16px;
            line-height: 21px;
            font-weight: bold;
            color: var(--color-black);
        }
        .resource-desc-box {
            margin-top: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .publish-name {
                max-width: 96px;
            }
            .publish-label {
                color: #666666;
                margin-left: 6px;
            }
            i {
                font-size: 16px;
                line-height: 16px;
                color: #999999;
            };
            .download-num {
                font-size: 14px;
                color: #999999;
                line-height: 19px;
                margin-left: 3px;
            }
        }
    }
    .resource-label {
        height: 24px;
        position: absolute;
        top: 0;
        right: 0;
        background: #D8F1E4;
        border-radius: 0px 4px 0px 4px;
        padding-left: 12px;
        padding-right: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #089950;
        line-height: 24px;
    }
    .tag {
        // border-radius: 0px 4px 0px 4px;
        // position: absolute;
        // right: 0px;
        // top: 0px;
        // padding: 2px 12px;
        // background: #D8F1E4;
        // color: #089950;

        // &.tag-1 {
        //     background: #D8F1E4;
        //     color: #089950;
        // }
        // &.tag-2 {
        //     background: #FDEFCD;
        //     color: #B27121;
        // }
        // &.tag-3 {
        //     background: #DEEBFD;
        //     color: #197FD7;
        // }
        display: inline-flex;
        height: 24px;
        background: #F3F6FA;
        border-radius: 2px;
        border: 1px solid #D8DDE6;
        padding: 0 7px;
        font-size: 14px;
        color: #586C80;
        line-height: 24px;
        margin-top: 10px;
        align-items: center;
    }
}

:deep(.link-item){
    width:100%;
    .list-item-link{
        display: flex;
        align-items: center;
    }
}
.resource-list-item:nth-child(3n+1) {
    margin-left: 0;
}
.ellipsis-2 {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.no-data {
    margin-top: 50px;
}
.text-overflow {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.ml12 {
    margin-left: 12px;
}
</style>